import { useEffect, useRef, useState } from "react";
import Apiservice from "../Apiservice";
import moment from "moment";
import {
    FaSearch,
    FaUndo,
    FaFileExcel,
    FaFilePdf,
} from "react-icons/fa";
import { PDFDownloadLink } from "@react-pdf/renderer";
import AttendanceReportPDF from "./AttendanceReportPDF";
import * as XLSX from "xlsx";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { formatDateTimeAuto } from "../Utils/Utils";

const AttendanceReport = () => {
    const location = useLocation();
    const [highlightId, setHighlightId] = useState(null);

    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [roleDetails, setRoleDetails] = useState([]);
    const [loggedUserId, setLoggedUserId] = useState(0);
    const [logInRoleId, setLogInRoleid] = useState(0);

    // const fromRef = useRef("");
    // const toRef = useRef("");
    // const user_idRef = useRef(0);
    // const employeeIdRef = useRef("");
    // const site_idRef = useRef(0);

    const fromRef = useRef(null);
    const toRef = useRef(null);
    const user_idRef = useRef(null);
    const employeeIdRef = useRef(null);
    const site_idRef = useRef(null);

    const [errors, setErrors] = useState({});
    const [sites, setSites] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLogInRoleid(localStorage.getItem('role_id'));
            setLoggedUserId(localStorage.getItem('user_id'));
            if (user_idRef.current) {
                user_idRef.current.value = localStorage.getItem('user_id');
            }
            let result = await Apiservice.AllSites({ status: 0 });
            //console.log(result)
            if (result.success === true) {
                setSites(result.data)
            }
        };
        fetchData();
    }, [])

    const validateForm = () => {
        const newErrors = {};
        if (!fromRef.current.value.trim()) newErrors.from = "From Date is required";
        if (!toRef.current.value.trim()) newErrors.to = "To Date is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    console.log("filters", {
        employeeId: employeeIdRef.current?.value,
        siteId: site_idRef.current?.value,
        from: fromRef.current?.value,
        to: toRef.current?.value
    });
    const fetchData = async () => {
        if (!validateForm()) return;
        setLoading(true);
        let requestData = {};
        if (logInRoleId == 1) {
            requestData = {
                entryTimeFrom: fromRef.current.value,
                entryTimeTo: toRef.current.value,
                status: 0,
                // userId: user_idRef.current.value ? parseInt(user_idRef.current.value) : 0,
                employeeId: employeeIdRef.current?.value || "",
                // siteId: site_idRef.current.value ? parseInt(site_idRef.current.value) : 0,
                siteId: Number(site_idRef.current?.value) || 0,
            };
        } else {
            requestData = {
                entryTimeFrom: fromRef.current.value,
                entryTimeTo: toRef.current.value,
                status: 0,
                userId: Number(loggedUserId),
                // employeeId: employeeIdRef.current?.value || "",
                // siteId: site_idRef.current.value ? parseInt(site_idRef.current.value) : 0,
                siteId: Number(site_idRef.current?.value) || 0,
            };
        }

        try {
            let result = await Apiservice.GetAttendance(requestData);
            
            // console.log("requestData", requestData);
            // console.log("result", result);

            if (result.success) {
                setData(result.data);
                setRoleDetails(result.data?.roleDetails);
            } else {
                console.error(result.message);
                setData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setData([]); // In case server itself fails
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => moment(dateString).format("DD-MM-YYYY");
    const formatTime = (utcTime) => {
        if (!utcTime) return "";

        const date = new Date(utcTime); // ISO UTC string

        return date.toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
            timeZone: "Asia/Kolkata"
        });
    };

    // const handleEdit = async (attendanceId) => {
    //     navigate(`/staffattendanceedit/${attendanceId}`)
    // };

    const handleEdit = async (userType, attendanceId) => {

        const filters = {
            from: fromRef.current?.value || "",
            to: toRef.current?.value || "",
            employeeId: employeeIdRef.current?.value || "",
            siteId: site_idRef.current?.value || ""
        };
        navigate('/staffattendanceedit', {
            state: {
                userType,
                attendanceId,
                fromPage: '/attendancereport',
                filters
            }
        });
    }
    const handleDeleteConfirm = async (attendanceId) => {
        const data = {
            'attendanceId': attendanceId,
            'status': 0
        };
        const token = localStorage.getItem("access_token");

        const headers = {
            access_token: token,
        };

        let result = await Apiservice.SoftDeleteAttendance(data);
        if (result.success === true) {
            setDeleteModal(false);
            setSelectedId(null); // Reset selected ID
            await fetchData(); // ✅ Refresh the data directly
        } else {
            alert(result.message);
        }
    };

    const handleReset = () => {
        if (fromRef.current) fromRef.current.value = "";
        if (toRef.current) toRef.current.value = "";
        if (employeeIdRef.current) employeeIdRef.current.value = "";
        if (site_idRef.current) site_idRef.current.value = 0;

        setErrors({});
        setData([]);
    };



    const exportToExcel = () => {
        if (!data.length) return;

        const exportData = data.map((d, index) => ({
            SNo: index + 1,
            // ...(user_idRef.current.value <= 0 && {
            ...(Number(user_idRef.current?.value || 0) <= 0 && { StaffID: d.user_id }),
            ...(Number(user_idRef.current?.value || 0) <= 0 && { Name: (d.userDetails?.firstName || "") + " " + (d.userDetails?.lastName || "") }),
            ...(Number(user_idRef.current?.value || 0) <= 0 && { Designation: d.userDetails?.roleName || "N/A" }),
            ...(Number(site_idRef.current?.value || 0) <= 0 && {
                SiteName: sites.find((site) => site.id === d.site_id)?.name || "N/A",
            }),
            CheckIn: formatDateTimeAuto(d.entryTime),
            CheckOut: d.exitTime ? formatDateTimeAuto(d.exitTime) : "N/A",
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");

        XLSX.writeFile(workbook, "Attendance_Report.xlsx");
    };

    useEffect(() => {

        const state = location.state;

        if (!state?.filters) return;

        const timer = setTimeout(() => {

            if (fromRef.current)
                fromRef.current.value = state.filters.from || "";

            if (toRef.current)
                toRef.current.value = state.filters.to || "";

            if (employeeIdRef.current)
                employeeIdRef.current.value = state.filters.employeeId || "";

            if (site_idRef.current)
                site_idRef.current.value = state.filters.siteId || "";

            setHighlightId(state.editedId);

            fetchData();

        }, 500);

        return () => clearTimeout(timer);

    }, [location.state]);

    useEffect(() => {

        if (!highlightId || data.length === 0) return;

        const row = document.getElementById(`attendance-row-${highlightId}`);

        if (row) {

            row.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });

            setTimeout(() => {
                setHighlightId(null);
            }, 5000);
        }

    }, [data, highlightId]);


    return (
        <div className="container-fluid p-3 shadow" style={{ backgroundColor: "#f8f9fa", userSelect: "none" }}>
            {/* Search Section */}
            <div
                className="card shadow-sm border-0 sticky-top"
                style={{
                    top: "0px",
                    zIndex: 100,
                    borderRadius: "15px",
                }}
            >
                <div className="card-body">
                    <div className="row g-3 align-items-end">

                        {/* From */}
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                            <label className="form-label fw-semibold">From</label>
                            <input
                                type="date"
                                className={`form-control ${errors.from ? "is-invalid" : ""}`}
                                ref={fromRef}
                            />
                            {errors.from && (
                                <div className="invalid-feedback">{errors.from}</div>
                            )}
                        </div>

                        {/* To */}
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                            <label className="form-label fw-semibold">To</label>
                            <input
                                type="date"
                                className={`form-control ${errors.to ? "is-invalid" : ""}`}
                                ref={toRef}
                            />
                            {errors.to && (
                                <div className="invalid-feedback">{errors.to}</div>
                            )}
                        </div>

                        {/* Employee */}
                        {logInRoleId == 1 && (
                            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                                <label className="form-label fw-semibold">
                                    Employee ID
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    ref={employeeIdRef}
                                    placeholder="Enter Employee ID"
                                />
                            </div>
                        )}

                        {/* Site */}
                        {logInRoleId == 1 && (
                            <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                                <label className="form-label fw-semibold">
                                    Site
                                </label>

                                <select
                                    className="form-select"
                                    ref={site_idRef}
                                >
                                    <option value="">All Sites</option>

                                    {sites.map((site) => (
                                        <option key={site.id} value={site.id}>
                                            {site.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        {/* Buttons */}
                        <div className="col-xl-4 col-lg-12 col-md-12">
                            <div className="d-flex align-items-center gap-2 flex-wrap justify-content-lg-end">

                                <button
                                    className="btn btn-primary d-flex align-items-center"
                                    onClick={fetchData} disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span
                                                className="spinner-border spinner-border-sm me-2"
                                                role="status"
                                            />
                                            Loading...
                                        </>
                                    ) : (
                                        <>
                                            <FaSearch className="me-1" />
                                            Search
                                        </>
                                    )}
                                </button>

                                <button
                                    className="btn btn-secondary d-flex align-items-center"
                                    onClick={handleReset}
                                >
                                    <FaUndo className="me-1" />
                                    Reset
                                </button>

                                {data.length > 0 && (
                                    <button
                                        className="btn btn-success d-flex align-items-center justify-content-center"
                                        onClick={exportToExcel}
                                        title="Download Excel"
                                    >
                                        <FaFileExcel />
                                    </button>
                                )}

                                {data.length > 0 && (
                                    <PDFDownloadLink
                                        document={
                                            <AttendanceReportPDF
                                                data={data}
                                                sites={sites}
                                                employeeId={employeeIdRef.current?.value}
                                                site_id={parseInt(site_idRef.current?.value)}
                                                from={fromRef.current?.value}
                                                to={toRef.current?.value}
                                            />
                                        }
                                        fileName="Attendance_Report.pdf"
                                        className="btn btn-danger d-flex align-items-center justify-content-center"
                                        style={{
                                            minWidth: "42px",
                                            height: "38px",
                                            textDecoration: "none",
                                        }}
                                    >
                                        {({ loading }) =>
                                            loading ? (
                                                <span className="spinner-border spinner-border-sm"></span>
                                            ) : (
                                                <FaFilePdf />
                                            )
                                        }
                                    </PDFDownloadLink>
                                )}

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* Data Display Section */}
            <div className="row mt-4">
                <div className="col-12">
                    {/* {site_idRef.current.value > 0 && ( */}
                    {Number(site_idRef.current?.value || 0) > 0 && (
                        <div className="card mb-4">
                            <div className="card-body d-flex align-items-center">
                                {/* Profile image commented */}
                                <div>
                                    {sites.length > 0 && (() => {
                                        const selectedSite = sites.find(
                                            (site) => site.id === Number(site_idRef.current.value)
                                        );
                                        return selectedSite ? (
                                            <>
                                                <h5 className="mb-1">{selectedSite.name}</h5>
                                                <p className="mb-1 text-muted">{selectedSite.mobileNo}</p>
                                                <p className="mb-1 text-muted">{selectedSite.emailId}</p>
                                            </>
                                        ) : null;
                                    })()}
                                </div>
                            </div>
                        </div>
                    )}

                    {(employeeIdRef.current?.value || "").trim().length > 0 && data.length > 0 && data[0].userDetails ? (
                        <div className="card mb-4">
                            <div className="card-body d-flex align-items-center">
                                <img
                                    src={data[0].userDetails?.profileImage || ""}
                                    alt="Profile"
                                    className="rounded-circle me-3"
                                    style={{ width: "80px", height: "80px", objectFit: "cover" }}
                                />
                                <div>
                                    <h5 className="mb-1">
                                        {`${data[0].userDetails?.firstName || ""} ${data[0].userDetails?.lastName || ""}`}
                                    </h5>
                                    <p className="mb-1 text-muted">{data[0].userDetails?.roleName}</p>
                                    <p className="mb-1 text-muted">Employee ID : {data[0].userDetails?.employeeId}</p>
                                    <p className="mb-1 text-muted">{data[0].userDetails?.emailId}</p>
                                    <p className="mb-0 text-muted">
                                        {`${data[0].userDetails?.countryCode || ""} ${data[0].userDetails?.mobileNo || ""}`}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ) : null}
                    <div className="table-responsive"
                        style={{
                            maxHeight: "70vh",
                            overflowY: "auto",
                            overflowX: "auto",
                        }}>
                        <table className="table table-striped table-hover table-responsive mb-0">
                            <thead className="table-dark"
                                style={{
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 50,
                                }}>
                                <tr>
                                    <th>#</th>
                                    {
                                        logInRoleId == 1 && (
                                            !(employeeIdRef.current?.value?.trim().length > 0
                                            ) && <th>Employee Id</th>
                                        )
                                    }

                                    {
                                        logInRoleId == 1 && (
                                            !(employeeIdRef.current?.value?.trim().length > 0
                                            ) && <th>Name</th>
                                        )
                                    }
                                    {
                                        logInRoleId == 1 && (
                                            !(employeeIdRef.current?.value?.trim().length > 0
                                            ) && <th>NRIC/FIN</th>
                                        )
                                    }

                                    {

                                        // !(user_idRef.current.value > 0) && <th>Grade</th>
                                        !(Number(user_idRef.current?.value || 0) > 0) && <th>Grade</th>

                                    }


                                    <th>Type of Duty</th>
                                    {/* {!(site_idRef.current.value > 0) && <th>Site Name</th>} */}
                                    {!(Number(site_idRef.current?.value || 0) > 0) && <th>Site Name</th>}
                                    <th>Time In</th>
                                    <th>Time Out</th>
                                    <th>Total Hours</th>
                                    <th>Time In Location</th>
                                    <th>Time Out Location</th>

                                    {
                                        logInRoleId == 1 && (
                                            <th>Action</th>
                                        )
                                    }


                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="12" className="text-center py-5">
                                            <div className="spinner-border text-primary"></div>
                                            <div className="mt-2">
                                                Loading attendance records...
                                            </div>
                                        </td>
                                    </tr>
                                ) : data.length > 0 ? (
                                    data.map((d, index) => {
                                        //  let state = JSON.parse(d.state); // Correctly placed variable declaration

                                        return (
                                            // <tr key={index}>
                                            <tr
                                                key={index}
                                                id={`attendance-row-${d.id}`}
                                                style={{
                                                    backgroundColor:
                                                        highlightId === d.id
                                                            ? "#fff3cd"
                                                            : ""
                                                }}
                                            >
                                                <td>{index + 1}</td>
                                                {
                                                    logInRoleId == 1 && (
                                                        !(employeeIdRef.current?.value?.trim().length > 0
                                                        ) && <td>{d.userDetails.employeeId ? d.userDetails.employeeId : '#'}</td>

                                                    )
                                                }

                                                {
                                                    logInRoleId == 1 &&
                                                    !((employeeIdRef.current?.value || "").trim().length > 0) && (
                                                        <td>
                                                            {d.userDetails.firstName
                                                                ? `${d.userDetails?.firstName || ""} ${d.userDetails?.lastName || ""}`
                                                                : d.staffName}
                                                        </td>
                                                    )
                                                }

                                                {(employeeIdRef.current?.value || "").trim().length === 0 && (
                                                    <td>{d.userDetails.nricOrFin ? d.userDetails.nricOrFin : d.nricOrFin}</td>
                                                )}


                                                {/* {!(user_idRef.current.value > 0) && <td>{d.roleDetails[0]?.name || "N/A"}</td>} Fixed Conditional Rendering */}
                                                {!(Number(user_idRef.current?.value || 0) > 0) && (
                                                    <td>{d.roleDetails[0]?.name || "N/A"}</td>
                                                )}
                                                <td>{d.dutyType ?? "-"}</td>

                                                {/* {!(site_idRef.current.value > 0) && <td>
                                                                    {sites.length > 0
                                                                        ? (sites.find(site => site.id === d.site_id)?.name || "N/A")
                                                                        : "N/A"
                                                                    }
                                                                </td>} */}

                                                {!(Number(site_idRef.current?.value || 0) > 0) && (
                                                    <td>
                                                        {sites.length > 0
                                                            ? (sites.find(site => site.id === d.site_id)?.name || "N/A")
                                                            : "N/A"
                                                        }
                                                    </td>
                                                )}
                                                <td>{d.entryTime && formatDateTimeAuto(d?.entryTime) || "N/A"}</td>
                                                <td>{d.exitTime && formatDateTimeAuto(d?.exitTime) || "N/A"}</td>
                                                <td>{d.totalHours || "N/A"}</td>
                                                <td>{<td>{d.entryMapUrl ? <a href={d.entryMapUrl} target="_blank" rel="noopener noreferrer">
                                                    View
                                                </a> : '-'}</td>}</td>
                                                <td>{<td>{d.exitMapUrl ? <a href={d.exitMapUrl} target="_blank" rel="noopener noreferrer">
                                                    View
                                                </a> : '-'}</td>}</td>

                                                {
                                                    logInRoleId == 1 && (
                                                        <td>
                                                            <td>
                                                                {/* <button className='btn btn-sm btn-primary' onClick={() => handleEdit(d.id)}>Edit</button> */}
                                                                <button
                                                                    className="btn btn-sm btn-primary m-2"
                                                                    onClick={() => handleEdit(d.userDetails.firstName ? 'normal' : 'floater', d.id)}
                                                                >
                                                                    Edit
                                                                </button>
                                                                <button
                                                                    key={d.id}
                                                                    className="btn btn-outline-danger btn-sm"
                                                                    onClick={() => {
                                                                        setSelectedId(d.id);
                                                                        setDeleteModal(true);
                                                                    }}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    Delete
                                                                </button>
                                                            </td>
                                                        </td>
                                                    )
                                                }


                                            </tr>

                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="13" className="text-center">No Data Found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
            {deleteModal && (
                <Modal show={deleteModal} onHide={() => setDeleteModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Delete ?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to Delete?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setDeleteModal(false)}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={() => handleDeleteConfirm(selectedId)}>
                            Delete
                        </Button>
                    </Modal.Footer>
                </Modal>

            )}
        </div>
    );
};

export default AttendanceReport;
